import React from 'react';
import PropTypes, { string } from 'prop-types';

import OptionList from 'jl-design-system/components/option/OptionList';
import RadioButton from 'jl-design-system/components/radio-button/RadioButton';

export const ProductRadios = ({ onChange, options, value: inputValue }) => (
  <OptionList name="list-radio" isButtonList onChange={onChange} isControlled>
    {options.map(({ id, key, label, value }) => (
      <RadioButton
        id={id}
        key={key}
        label={label}
        value={value}
        isControlled
        checked={id === inputValue}
      />
    ))}
  </OptionList>
);

export const MemoizedProductRadios = React.memo(ProductRadios);

ProductRadios.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
